import { render, staticRenderFns } from "./InvitationFormCompetitive.vue?vue&type=template&id=3c974f9f&scoped=true"
import script from "./InvitationFormCompetitive.vue?vue&type=script&lang=js"
export * from "./InvitationFormCompetitive.vue?vue&type=script&lang=js"
import style0 from "./InvitationFormCompetitive.vue?vue&type=style&index=0&id=3c974f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c974f9f",
  null
  
)

export default component.exports